import React, { useEffect, useState } from 'react'
import { makeStyles, InputAdornment, IconButton } from '@material-ui/core'
import { EInputBase } from 'src/mobile/themes/components/ETextField'
import { ReactComponent as SearchIcon } from 'src/mobile/assets/icons/search.svg'
import { useCustomTranslation } from 'src/hooks'
import { ReactComponent as CancelIcon } from 'src/mobile/assets/icons/cancel.svg'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  root: {},
  searchInput: {
    width: '100%',
    fontSize: 16,
    height: theme.spacing(7),
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      marginBottom: theme.spacing(1.5),
      minWidth: 'auto',
    },
    '& path': {
      fill: theme.palette.grey[500],
    },
  },
  regionWrapper: {
    marginTop: theme.spacing(4),
    marginLeft: theme.spacing(2),
  },
  regionItem: {
    color: theme.palette.primary.main,
  },
  cancelIcon: {
    '& path': {
      fill: theme.palette.secondary.main,
    },
  },
}))

const Search = ({ changeclearbtn, clearbtn, data, setSearchResult, changeselectShow, isFAQ }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [query, setQuery] = useState('')
  const [tB] = useCustomTranslation()

  useEffect(() => {
    if (!query) setSearchResult(data)
  }, [data, query])
  useEffect(() => {
    if (clearbtn) {
      handleCancel()
      changeclearbtn(false)
    }
  }, [clearbtn])

  const handleSearch = (e) => {
    if (e.target.value.length <= 50) {
      setQuery(e.target.value)
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })
    const regex = new RegExp(e.target.value, 'i')
    changeselectShow(false)
    try {
      const result = e.target.value
        ? data?.filter((item) => regex?.test(item[tB('question')]) || regex?.test(item[tB('content')])) || []
        : data
      setSearchResult(result, e.target.value)
      if (e.target.value.length === 0) {
        handleCancel()
      }
    } catch (err) {
      console.error(err)
    }
  }

  const handleSearchSubmit = async (e) => {
    e.preventDefault()
  }
  // 显示出选项框
  const handleCancel = () => {
    changeselectShow(true)
    setQuery('')
  }

  return (
    <form id="search-box" noValidate onSubmit={handleSearchSubmit}>
      <EInputBase
        backgroundColor="none"
        className={classes.searchInput}
        placeholder={t('glossary.search_keyword')}
        value={query}
        onInput={handleSearch}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon color="disabled" />
          </InputAdornment>
        }
        endAdornment={
          query ? (
            <InputAdornment position="end">
              <IconButton size="small" color="secondary" onClick={handleCancel}>
                <CancelIcon className={classes.cancelIcon} />
              </IconButton>
            </InputAdornment>
          ) : null
        }
      />
    </form>
  )
}

export default Search
